import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTodos: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="todos,check,things, task"><path d="M15.75 20.25H20.25V3.75H3.75V20.25H8.25M9 13.0929L11.2327 15.0599L15.14 9.43994" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTodos;
